import React from 'react';
import Image from '../../../../components/AppImage';

export const renderPartnerLogo = (partner) => {
  if (!partner.logo || partner.logo === "") {
    return null;
  }

  const logoElement = (
    <Image
      src={partner.logo}
      alt={partner.logoAlt || partner.name}
      className={`${partner.isLarge ? 'max-h-40' : 'max-h-32'} w-auto object-contain transition-transform duration-300 hover:scale-110 cursor-pointer`}
      style={partner.isBlack ? { filter: 'brightness(0)' } : {}}
    />
  );

  if (partner.website) {
    return (
      <a
        href={partner.website}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Visit ${partner.name} website`}
        className="block"
      >
        {logoElement}
      </a>
    );
  }
  return logoElement;
};

export const partnersContent = {
  ar: {
    whoAreWeTitle: "من نحن",
    organizersTitle: "المنظمين",
    sponsorsTitle: "الرعاة",
    strategicSponsorTitle: "الراعي الاستراتيجي",
    diamondSponsorTitle: "الراعي الماسي",
    goldSponsorTitle: "الراعي الذهبي",
    silverSponsorTitle: "الراعي الفضي",
    technicalSponsorTitle: "الراعي الفني",
    technicalPartnerTitle: "الراعي التقني",
    successPartnersTitle: "شركاء النجاح"
  },
  en: {
    whoAreWeTitle: "Who are we",
    organizersTitle: "Organizers",
    sponsorsTitle: "Sponsors",
    strategicSponsorTitle: "Strategic Sponsor",
    diamondSponsorTitle: "Diamond Sponsor",
    goldSponsorTitle: "Gold Sponsor",
    silverSponsorTitle: "Silver Sponsor",
    technicalSponsorTitle: "Technical Sponsor",
    technicalPartnerTitle: "Technical Partner",
    successPartnersTitle: "Success Partners"
  },
  tr: {
    whoAreWeTitle: "Biz kimiz",
    organizersTitle: "Organizatörler",
    sponsorsTitle: "Sponsorlar",
    strategicSponsorTitle: "Stratejik Sponsor",
    diamondSponsorTitle: "Elmas Sponsor",
    goldSponsorTitle: "Altın Sponsor",
    silverSponsorTitle: "Gümüş Sponsor",
    technicalSponsorTitle: "Teknik Sponsor",
    technicalPartnerTitle: "Teknik Ortak",
    successPartnersTitle: "Başarı Ortakları"
  }
};

